import { Component, OnChanges } from '@angular/core';
import { TreeNode } from 'primeng/api';
import { filter } from 'rxjs/operators';
import { BaseComponent } from '../../shared/base-components/base.component';
import { MvdModalService } from '../../shared/services/modal/mvd-modal.service';
import { CustomerAffiliation } from '../models/customer-affiliation.model';
import { CustomerAffiliationRoleType } from '../models/enums/customer-affiliation-role-type.enum';
import { CustomerAffiliationType } from '../models/enums/customer-affiliation-type.enum';
import { CustomerManageService } from '../shared/customer-manage.service';
import { AffiliationContext, CustomerAffiliationEditComponent } from './customer-affiliation-edit.component';
import { HistoricalAffiliationContext, HistoricalCustomerAffiliationModalComponent } from './historical-customer-affiliation-modal.component';

@Component({
    selector: 'customer-affiliation',
    templateUrl: './customer-affiliation.html',
    inputs: ['customerNumber', 'canEdit']
})

export class CustomerAffiliationComponent extends BaseComponent implements OnChanges {
    public affiliations: CustomerAffiliation[];
    public customerNumber: number;
    public affiliationNodes: TreeNode[];
    public rootNode: TreeNode[];
    public affiliationId: number;
    public canEdit: boolean;
    private affiliationTypes = new CustomerAffiliationRoleType();
    private roleTypes = new CustomerAffiliationType();

    constructor(
        public modalService: MvdModalService,
        private customerService: CustomerManageService) {
        super();
    }

    ngOnInit() {
        this.affiliationNodes = new Array<TreeNode>();
        this.rootNode = new Array<TreeNode>();
        this.affiliationId = 0;

        if (this.customerNumber != null) {
            this.populateAffiliations(this.customerNumber);
        }
    }

    ngOnChanges() {
        if (this.customerNumber != null) {
            this.populateAffiliations(this.customerNumber);
        }
    }

    populateAffiliations(customerNumberId: number) {
        this.customerService.getCustomerAffiliations(customerNumberId)
            .subscribe(result => {
                this.affiliations = result;
            },
            e => this.handleValidationResult(e),
            () => {
                this.denormalizeData();
            });
    }

    denormalizeData() {
        this.rootNode = [];
        this.affiliationNodes = [];

        if (this.affiliations !== undefined) {
            for (const affiliation of this.affiliations) {
                const children = [];
                for (const child of affiliation.members) {
                    children.push({
                        'type': 'child',
                        'data': { 'name': child.customerName, 'description': child.customerAffiliationRoleTypeDisplayValue }
                    });
                }

                this.affiliationNodes.push({
                    'label': affiliation.customerAffiliationTypeDisplayValue,
                    'type': 'parent',
                    'data': { 'customerNumber': affiliation.customerNumberID, 'affiliationId': affiliation.id },
                    'children': children
                });
            }
        }

        this.rootNode.push({ 'label': 'Affiliations', 'expanded': true, 'type': 'root', 'children': this.affiliationNodes });
    }

    addAffiliation() {
        const data = new AffiliationContext(0, this.customerNumber);
        this.modalService.open(CustomerAffiliationEditComponent, data).afterClosed()
            .pipe(filter(result => !!result))
            .subscribe(() => this.populateAffiliations(this.customerNumber));
    }

    editAffiliation(node) {
        this.affiliationId = node.data.affiliationId;
        const data = new AffiliationContext(this.affiliationId, this.customerNumber);

        this.modalService.open(CustomerAffiliationEditComponent, data).afterClosed()
            .pipe(filter(result => !!result))
            .subscribe(result => this.populateAffiliations(this.customerNumber));
    }

    showHistory(id) {
        const data = new HistoricalAffiliationContext(this.customerNumber);
        this.modalService.open(HistoricalCustomerAffiliationModalComponent, data);
    }
}
